import { useLayoutEffect } from 'react';
import { useStartupBootstrap } from './app/bootstrap/useStartupBootstrap';
import { LoadingScreen } from './features/auth/components/LoadingScreen';
import { WorkspaceApp } from './features/workspace/WorkspaceApp';

export default function App() {
  const startup = useStartupBootstrap();
  const appVisible = startup.phase === 'appVisible';
  const exiting = startup.phase === 'exiting';
  const showLoading = !appVisible;

  useLayoutEffect(() => {
    if (!appVisible || !startup.result) return undefined;
    const frame = window.requestAnimationFrame(() => startup.onAppInteractive());
    return () => window.cancelAnimationFrame(frame);
  }, [appVisible, startup.onAppInteractive, startup.result]);

  return (
    <div className="startup-shell">
      {startup.result && (appVisible || exiting) ? (
        <div
          className="startup-shell__workspace"
          inert={exiting}
          aria-hidden={exiting ? 'true' : undefined}
        >
          <WorkspaceApp
            initialAppConfig={startup.result.appConfig}
            initialAuthState={startup.result.authState}
          />
        </div>
      ) : null}

      {showLoading ? (
        <LoadingScreen
          exiting={exiting}
          exitDurationMs={startup.exitDurationMs}
          onVisibilityOpportunity={startup.onVisibilityOpportunity}
        />
      ) : null}
    </div>
  );
}
